import { ArrowRight, LogIn, UserPlus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import usePublicEconomics from '@/hooks/usePublicEconomics';

const FinalCTA = ({ referralCode = null }) => {
  const { authUser, bootLoading } = useAuth();
  const { positionCost } = usePublicEconomics();
  const isAuthed = !bootLoading && !!authUser;
  const signupHref = referralCode ? `/signup?ref=${encodeURIComponent(referralCode)}` : '/signup';

  return (
    <section id="pool" className="relative max-w-7xl mx-auto px-5 md:px-8 pb-20 md:pb-28" data-testid="final-cta">
      <div className="sc-glass-strong rounded-3xl p-8 md:p-14 relative overflow-hidden">
        <div
          className="absolute -top-20 -right-20 w-[420px] h-[420px] pointer-events-none"
          style={{
            background: 'radial-gradient(circle, rgba(255, 182, 18, 0.20), transparent 60%)',
          }}
        />
        <div className="relative z-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="max-w-2xl">
            <div className="sc-pill">
              <span className="sc-dot" />
              Ready When You Are
            </div>
            <h3 className="font-display mt-5 text-[30px] md:text-[44px] leading-[1.05] font-bold tracking-tight">
              The engine is live. <span className="sc-gold-text">Step in.</span>
            </h3>
            <p className="mt-4 text-[15px] md:text-[17px] leading-relaxed text-[var(--sc-text-dim)]">
              Affordable <strong className="text-[#FFE08A]">{positionCost} micro-positions</strong>, 52-week automated compounding momentum, and a transparent
              dual-heartbeat engine alternating between Random and FIFO cycles. Lock in your positions, start your Sub Packs, and let the engine work.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            {isAuthed ? (
              <Link to="/dashboard" className="sc-btn-gold" data-testid="final-cta-dashboard">
                <ArrowRight className="w-4 h-4" strokeWidth={2.6} />
                Go to Dashboard
              </Link>
            ) : (
              <>
                <Link to={signupHref} className="sc-btn-gold" data-testid="final-cta-signup">
                  <UserPlus className="w-4 h-4" strokeWidth={2.6} />
                  Sign Up Now
                </Link>
                <Link to="/login" className="sc-btn-ghost" data-testid="final-cta-login">
                  <LogIn className="w-4 h-4" strokeWidth={2.4} />
                  Login
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
